export default "__VITE_ASSET__BuvvQfdH__"